/**
 * Route path constants
 * Centralized route definitions for type-safe navigation
 */
export const ROUTES = {
    HOME: '/',
    LOGIN: '/login',
    REGISTER: '/register',
    USERS: '/users',
    SYSTEM_PROMPT: '/system-prompt',
    REFERENCE_LIST_CONFIGURATION: '/reference-list-configuration',
    REFERENCE_LIST_CONFIGURATION_NEW: '/reference-list-configuration/new',
    REFERENCE_LIST_CONFIGURATION_DATA: '/reference-list-configuration/:id/data',
    REFERENCE_LIST_CONFIGURATION_EDIT: '/reference-list-configuration/:id',
    ZONES_CONFIGURATION: '/zones-configuration',
    ZONES_CONFIGURATION_NEW: '/zones-configuration/new',
    ZONES_CONFIGURATION_EDIT: '/zones-configuration/:id',
    REPORTS: '/reports',
    NEW_REPORT: '/reports/new',
    REPORT_DETAIL: '/reports/:id',
    TEMPLATES: '/templates',
    TEMPLATE_DETAIL: '/templates/:id',
    REPORT_CATEGORY_CONFIG: '/report-category-config',
    PROFILE: '/profile',
    SETTINGS: '/settings',
    SHOWCASE: '/showcase',
    DOCS: '/docs',
    MOCK: '/mock',
    UNAUTHORIZED: '/unauthorized',
    NOT_FOUND: '*',
} as const;

export type RouteKey = keyof typeof ROUTES;
export type RoutePath = typeof ROUTES[RouteKey];
